import React from 'react';
import Modal from '@omilia/modal';
import { Form, Field } from 'react-final-form';
import Button, { ButtonGroup } from '@omilia/button';
import styled from 'styled-components';

import TextFieldFinalFormWrapper from 'components/TextFieldFinalFormWrapper';
import validate from './utils/validate';
import { Props } from './types';

const SForm = styled.form`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const CreateNewIntentModal = ({
  initialValues,
  onSubmit,
  onClose,
  onCheckIntentName,
}: Props) => (
  <Modal
    open
    shouldCloseOnBackdropClick
    shouldCloseOnEscPress
    glyph="intents"
    title="Create Intent"
    onClose={onClose}
  >
    <Form initialValues={initialValues} onSubmit={onSubmit}>
      {({ handleSubmit, invalid, submitting }) => (
        <SForm data-test="intent-form" onSubmit={handleSubmit}>
          <Field
            component={TextFieldFinalFormWrapper}
            data-test="intent-name"
            label="INTENT NAME"
            name="intentName"
            placeholder="Please type a name for the intent"
            validate={value => validate(value, onCheckIntentName)}
          />
          <ButtonGroup>
            <Button
              color="secondary"
              data-test="cancel-create-intent-button"
              variant="text"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              data-test="create-intent-button"
              disabled={invalid}
              loading={submitting}
              type="submit"
              variant="contained"
            >
              Create
            </Button>
          </ButtonGroup>
        </SForm>
      )}
    </Form>
  </Modal>
);

export default CreateNewIntentModal;
